import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=4407884b"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4407884b')) {
      api.createRecord('4407884b', component.options)
    } else {
      api.reload('4407884b', component.options)
    }
    module.hot.accept("./upgrade.vue?vue&type=template&id=4407884b", function () {
      api.rerender('4407884b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesman/staffManage/upgrade.vue"
export default component.exports